import { render, staticRenderFns } from "./NationalMaterials.vue?vue&type=template&id=1bc575c6&scoped=true&"
import script from "./NationalMaterials.vue?vue&type=script&lang=js&"
export * from "./NationalMaterials.vue?vue&type=script&lang=js&"
import style0 from "./NationalMaterials.vue?vue&type=style&index=0&id=1bc575c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc575c6",
  null
  
)

export default component.exports